import script from "./GuideAdminPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideAdminPage.vue?vue&type=script&setup=true&lang=ts"

import "./GuideAdminPage.vue?vue&type=style&index=0&id=3212bd21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3212bd21"]])

export default __exports__